import React from 'react';
import {
  Typography,
  Box,
  Button,
  Grid
} from '@material-ui/core';
import PageBg from './assets/images/404-page.svg';
import Logo from './assets/images/lcg-logo@3x.png'
import openIcon from './assets/images/icn-go@3x-white.png'

import { injectIntl, FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles';
import animation404 from './404.json'
import Lottie from 'react-lottie';
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  root: {
    background: "rgba(0,19,36,1)",
    width: "100vw",
    height: "100vh",
    color: "#fff",
    "& .content-block": {
      width: "100%",
      textAlign: "center",
      padding: "0px 24px",
      flexDirection: "column",
      position: "absolute",
      top: "10%",
      left: "50%",
      transform: "translate(-50%,0%)",
      display: "flex",
      margin: "0px auto",
      alignItems: "center",
      [theme.breakpoints.down('sm')]: {
        top: "50%",
        transform: "translate(-50%,-50%)",
      }
    },
    "& .logo": {
      width: "90px",
      height: "auto",
      [theme.breakpoints.down('sm')]: {
        display: "none"
      }
    },
    "& .title": {
      margin: "12px 0px 20px 0px",
      fontSize: "24px",
      color: "#fff",
      fontWeight: "normal",
      opacity: "0.8",
      [theme.breakpoints.down('sm')]: {
        display: "none"
      }
    },
    "& .description": {
      color: "#d9d9d9",
      fontSize: "16px",
      fontWeight: "normal",
      opacity: "0.8",
      margin: "0px 0px 24px 0px",
      [theme.breakpoints.down('sm')]: {
        fontSize: "12px"
      },
    },
    "& .lottie-block": {
      width: "100%",
      maxWidth: "530px"
    },
    "& .open-button": {
      color: "#fff",
      cursor: "pointer",
      border: "1px solid rgba(255,255,255,0.5)",
      padding: "12px 36px",
      margin: "0px",
      display: "inline-block",
      borderRadius: "4px",
      fontSize: "16px",
      [theme.breakpoints.down('sm')]: {
        fontSize: "12px"
      },
      [theme.breakpoints.down('xs')]: {
      },
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.04)"
      }
    },
    "& .white-arrow": {
      verticalAlign: "middle",
      height: "5px",
      width: "33px",
      margin: "0px 0px 6px 20px"
    }
  }
}))
const NotFound404 = (props: any) => {
  const { intl } = props
  const classes = useStyles()
  const initialOptions = {
    loop: true,
    autoplay: true,
    animationData: animation404,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return (
    <div className={classes.root}>
      <div className="content-block">
        <img className="logo" src={Logo} alt="logo" />
        <h1 className="title">
          {intl.formatMessage({ id: "error.404.title" })}
        </h1>

        <div className="lottie-block">
          <Lottie options={initialOptions} />
        </div>
        <p className="description">
          {intl.formatMessage({ id: "error.404.description" })}
        </p>
        <Button className="open-button" component={Link} to="/">
          {intl.formatMessage({ id: `error.404.button` })}
          <img className="white-arrow" src={openIcon} alt="" />
        </Button>
      </div>
    </div>
  )
}

export default injectIntl(NotFound404)